import { Button, Dialog, DialogContent } from "@mui/material";
import { CloseableDialogTitle } from "../../../../../components/dialog/CloseableDialogTitle";
import React from "react";
import { Callout, CalloutVariant } from "../../../../../components/Callout";

type TechnicalAndOrganizationalSecurityMeasuresDialogProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const TechnicalAndOrganizationalSecurityMeasuresDialog = ({
  isOpen,
  onClose,
}: TechnicalAndOrganizationalSecurityMeasuresDialogProps) => {
  return (
    <Dialog
      className="help-dialog"
      open={isOpen}
      fullWidth={true}
      maxWidth={"md"}
      onClose={onClose}
      aria-label="Examples of Technical and Organizational Security Measures"
    >
      <CloseableDialogTitle onClose={onClose}>
        Examples of Technical and Organizational Security Measures
      </CloseableDialogTitle>
      <DialogContent className="help-dialog-content">
        <p>
          Businesses should implement appropriate security measures to protect the personal data
          under their control. What is appropriate can vary according to the context, taking into
          account such factors as the types of technology available, the cost of implementing the
          measures, and the level of risk posed to those individuals whose data is being collected.
          (For example, storing social security numbers poses substantially more risk than storing
          telephone numbers.)
        </p>
        <Callout variant={CalloutVariant.LightPurple}>
          <h4 className="mt-xs">Common security measures include:</h4>
          <ul>
            <li>Physical premises security (video surveillance, keycard locks, etc.)</li>
            <li>Data encryption</li>
            <li>Data anonymization or pseudonymization</li>
            <li>Password protection</li>
            <li>Access control (i.e., restricting access to certain roles within the company)</li>
            <li>Anti-malware systems</li>
            <li>Security awareness training</li>
            <li>Zero-trust architecture</li>
          </ul>
        </Callout>
        <div className="mt-md" style={{ textAlign: "right" }}>
          <Button variant="contained" color="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
